export const COMMON = {
  APIURL: "https://api.appon.vn/v1",
  URL_PAGE_DEMO: "https://app.appon.vn/"
};
